import { Alert, AlertTitle, Box, Button, Chip, Grid, Stack, Typography } from "@mui/material";
import { useGetMerchantQuery, useLazyGetB2BOdaCheckQuery } from "../../redux/commonRTK";
import { getMerchant } from "../../helpers/ReduxHelpers";
import { FormSkeleton } from "../../common/Skeletons";
import { RHFSearchableSelectField } from "../../common/hook-form";
import _ from "lodash";
import { addressString } from "../../helpers/UtilityHelper";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

function DropLocation({ setActiveStep }) {
    const merchant = getMerchant();
    const selectedDeliveryLocationId = useWatch({ name: 'delivery_location' })
    const { setValue, trigger } = useFormContext()

    const { data, isLoading, isFetching } = useGetMerchantQuery({ id: merchant.id })

    const [triggerOdaCheck, { data: odaData, isFetching: odaFetching }] = useLazyGetB2BOdaCheckQuery()

    const deliveryLocations = data?.deliveryLocationList || [];

    const deliveryLocationOptions = _(deliveryLocations)
        .filter({ status: 'ACTIVE', address_type: 'DELIVERY' })
        .map((loc) => ({
            value: loc.id,
            label: addressString(loc)
        })).value()

    React.useEffect(() => {
        const selectedDeliveryLocation = _.find(deliveryLocations, { id: selectedDeliveryLocationId });
        const pincode = selectedDeliveryLocation?.pincode || '';
        setValue('delivery_details', {
            to_name: selectedDeliveryLocation?.name || selectedDeliveryLocation?.receiver_name,
            to_phone_number: selectedDeliveryLocation?.contactNumber || '',
            to_address: selectedDeliveryLocation?.address_line || '',
            to_email: selectedDeliveryLocation?.email || '',
            to_pincode: pincode,
            to_city: selectedDeliveryLocation?.city || '',
            to_state: selectedDeliveryLocation?.state || '',
            to_country: selectedDeliveryLocation?.country || '',
            gstin: selectedDeliveryLocation?.gstin || '',
        })

        if (pincode && merchant?.id) {
            triggerOdaCheck({ pincode, merchantOid: merchant.id })
        }

        // eslint-disable-next-line
    }, [selectedDeliveryLocationId])

    const odaResults = (odaData?.results || []).filter((r) => r?.oda)
    const showOdaAlert = !odaFetching && selectedDeliveryLocationId && odaResults.length > 0

    if (isLoading || isFetching) {
        return <FormSkeleton />
    }

    const onNextHandler = async () => {
        const status = await trigger(['delivery_location', 'delivery_details']);
        if (status) {
            setActiveStep(2)
        }
    }

    const onKeyPressHandler = (e) => {
        if (e.charCode === 13) {
            onNextHandler();
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sx={{ mb: 3 }}>
                <RHFSearchableSelectField
                    options={deliveryLocationOptions}
                    width="100%"
                    label="Please Select Delivery Location*"
                    name="delivery_location"
                    onKeyPress={onKeyPressHandler}
                    autoFocus={true}
                />
                <Typography variant="body2">
                    If Delivery Location is not present then create a new
                    <Button sx={{ py: 0, textTransform: 'none' }} target="_blank" href="/delivery-location">
                        Delivery Location
                    </Button>
                </Typography>
                {showOdaAlert && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        <AlertTitle>Destination Pincode falls under ODA service area.</AlertTitle>
                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                            Affected couriers ({odaResults.length}):
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {odaResults.map((r) => (
                                <Chip
                                    key={r.cp}
                                    size="small"
                                    color="warning"
                                    variant="outlined"
                                    label={`${r.cp}${r.odaValue ? ` — ${r.odaValue}` : ''}`}
                                />
                            ))}
                        </Box>
                    </Alert>
                )}
            </Grid>
            <Grid item xs={12}>
                <Stack direction="row" columnGap={1}>
                    <Button variant="contained" size="small" color="error" onClick={() => setActiveStep(0)}>Prev</Button>
                    <Button variant="contained" size="small" onClick={onNextHandler}>Next</Button>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default DropLocation;